import { CATEGORIZATION_VISIBLE_FOLDERS_KEY } from '../../../../../constants/localStorage'

export const setCategorizationVisibleLists = (value) => (localStorage[CATEGORIZATION_VISIBLE_FOLDERS_KEY] = value)

export const getCategorizationVisibleLists = () => {
  return localStorage[CATEGORIZATION_VISIBLE_FOLDERS_KEY]
}
